import { useTranslation } from 'react-i18next';
import { FaGoogle, FaMicrosoft } from 'react-icons/fa';
import { startSsoUrl } from '@/api/rysApi';
import { Button } from '@/ui';

export function SsoButtons({ returnUrl }: { returnUrl: string }) {
  const { t } = useTranslation();
  return (
    <div style={{ display: 'grid', gap: '0.5rem', marginTop: '1rem' }}>
      <Button id="sso-google" variant="outline" block href={startSsoUrl('google', returnUrl)}>
        <FaGoogle size={16} /> {t('login.continueWithGoogle')}
      </Button>
      <Button id="sso-microsoft" variant="outline" block href={startSsoUrl('microsoft', returnUrl)}>
        <FaMicrosoft size={16} /> {t('login.continueWithMicrosoft')}
      </Button>
    </div>
  );
}
